import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { A as Autoplay } from './embla-carousel-autoplay.esm-BukruCx2.js';

class AnnouncementBar extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;
  #autoplayDelay = parseInt(this.dataset.autoplayDelay);

  connectedCallback() {
    this.#embla = EmblaCarousel(
      this.querySelector('.embla__viewport'),
      {
        direction: document.dir || 'ltr',
        active: this.querySelectorAll('.embla__slide').length > 1,
        loop: true,
      },
      [Autoplay({ delay: this.#autoplayDelay })]
    );

    this.#embla.plugins().autoplay?.play();
  }
}

customElements.define('announcement-bar', AnnouncementBar);
